import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ProposalTemplatesPage } from "@/features/proposaltemplates/ProposalTemplatesPage";

const search = z.object({
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/proposals/templates")({
  validateSearch: search,
  component: () => <ProposalTemplatesPage search={Route.useSearch()} />,
});
